import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PaymentV2Service, StorageService, UtilService, VariablesService } from '../../shared/services';
import { IPaymentSipConfig } from '../payment-sip/payment-sip.model';
import { ActivatedRoute } from '@angular/router';
import { ISipCause, SipStatus } from 'src/app/shared/models/sip-cause.model';
import { IUser } from 'src/app/shared/models';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'app-multi-cause-sip-selection',
  templateUrl: './multi-cause-sip-selection.component.html',
  styleUrls: ['./multi-cause-sip-selection.component.scss']
})
export class MultiCauseSipSelectionComponent implements OnInit, OnDestroy {

  @Input() config: IPaymentSipConfig = {};
  is_mobile = false;

  cause_list = [
    { sip_cause: 'medical', title: 'Medical', icon: 'medical_services', amount: 0, lock_amount: false, plan: '', status: 0 },
    { sip_cause: 'animals', title: 'Animals', icon: 'pets', amount: 0, lock_amount: false, plan: '', status: 0 },
    { sip_cause: 'food_hunger', title: 'Food & Hunger', icon: 'restaurant', amount: 0, lock_amount: false, plan: '', status: 0 },
    { sip_cause: 'education', title: 'Education', icon: 'school', amount: 0, lock_amount: false, plan: '', status: 0 },
    { sip_cause: 'acid_victims', title: 'Acid Attack Victims', icon: 'volunteer_activism', amount: 0, lock_amount: false, plan: '', status: 0 },
  ]

  selected_causes: ISipCause[] = [];
  selected = [];

  subs: Subscription[] = [];
  params;
  show_min_error = false;

  user_data: IUser;
  is_agent = false;

  sipStatus = SipStatus;

  disable_status_regex = /^(1|5)$/;

  min_sip_error = false;
  exist_sip = [];
  today: Date = new Date();
  nextMonth: Date = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 1);
  maxStartDate: Date = new Date(this.nextMonth.getFullYear(), this.nextMonth.getMonth() + 1, 0);
  selectedDate;

  constructor(
    private paymentV2: PaymentV2Service,
    public util: UtilService,
    public actRoute: ActivatedRoute,
    private storage: StorageService,
    public vars: VariablesService
  ) { }

  ngOnInit(): void {
    this.is_mobile = this.util.isMobile();
    this.selectedDate = '';
    this.params = this.actRoute.snapshot.queryParams;
    this.vars.userData.subscribe(u => {
      this.user_data = u;
    });
    let sess_data: any = this.storage.getFromSession('multicause');
    if (sess_data) {
      this.paymentV2.paymentConfig.next({ amount: sess_data.amount, sip_cause: sess_data, cart_amount: sess_data.cart_amount });
    }
    if (this.params?.utm_source?.match('internal_impact_calling')) {
      this.is_agent = true;
      this.cause_list.push({ sip_cause: 'elderly', title: 'Elderly', icon: 'elderly', amount: 0, lock_amount: false, plan: '', status: 0 });
      this.cause_list.push({ sip_cause: 'women_girls', title: 'Women Empowerment', icon: 'woman', amount: 0, lock_amount: false, plan: '', status: 0 });
    }
    if (this.params?.pre_sip_cause || this.params?.sip_cause) {
      this.setInitial(this.util.stringToJson(this.params?.pre_sip_cause || this.params?.sip_cause));
    }
    this.subs.push(this.paymentV2.paymentConfig.subscribe((c) => {
      if (c) {
        this.config = { ...this.config, ...c };
        if (c?.user && this.config.amount) {
          this.checkExistingSip();
        }
        if (c?.amount && this.config.user) {
          this.selected.forEach(val => { this.setCauseAmount(val, c?.amount) });
        }
      }
    }));
  }

  setInitial(data: ISipCause[]) {
    if (data) {
      data.forEach(item => {
        this.setCause(item, item?.amount);
      });
    } else {
      this.setCause(this.cause_list[0]);
    }
  }

  checkExistingSip() {
    this.exist_sip = Object.keys(this.config?.user?.listsubscriptions);
    if (this.is_agent) {
      this.cause_list = this.cause_list.map(item => {
        item.status = this.user_data.listsubscriptions?.[item?.sip_cause]?.status_flag || item.status;
        if (this.disable_status_regex.test(item?.status?.toString())) {
          item.amount = this.user_data.listsubscriptions?.[item?.sip_cause]?.amount;
          item.lock_amount = true;
        }
        return item;
      });
      this.cause_list = this.cause_list.sort(this.sortActiveToBottom);
    } else {
      this.cause_list = this.cause_list.filter(obj => !this.exist_sip.includes(obj.sip_cause));
    }
    if (this.selected.length === 0) {
      this.setCause(this.cause_list[0]);
    }
  }

  sortActiveToBottom = (a, b) => {
    const sorting_order = [0, 3, 2, 4, 1, 5];
    const a_index = sorting_order.indexOf(a.status);
    const b_index = sorting_order.indexOf(b.status);
    if (a_index === b_index) {
      return 0;
    } else {
      return a_index - b_index;
    }
  }

  checklist(item, e?) {
    if (e?.target?.className?.match('amount-input') || (this.selected.length === 1 && this.selected.includes(item?.sip_cause)) || this.disable_status_regex.test(item?.status?.toString())) {
      return;
    }
    this.setCause(item);
  }

  setCause(item: any, amt?: number) {
    const amount = amt || this.config.amount;
    if (this.selected_causes.filter(val => val.sip_cause === item?.sip_cause).length === 0) {
      const selected_item = { sip_cause: item?.sip_cause, amount: amount };
      if (item?.plan) {
        selected_item['plan'] = item.plan;
      }
      this.selected_causes.push(selected_item);
      this.selected.push(item?.sip_cause);
      this.setCauseAmount(item?.sip_cause, amount);
    } else {
      this.selected_causes = this.selected_causes.filter(val => val.sip_cause !== item?.sip_cause);
      this.selected = this.selected.filter(val => val !== item?.sip_cause);
    }
    this.setConfig();
  }

  setCauseAmount(cause: string, amount: number) {
    const selected_item = this.cause_list.filter(item => item.sip_cause === cause)[0];
    if (selected_item.lock_amount) {
      amount = selected_item.amount;
    }
    this.selected_causes = this.selected_causes.map(obj => {
      if (obj.sip_cause === cause) {
        obj.amount = amount;
      }
      return obj;
    });
    this.cause_list = this.cause_list.map(obj => {
      if (obj.sip_cause === cause) {
        obj.amount = amount;
      }
      return obj;
    });
    this.setConfig();
  }

  changeAmount(cause, e) {
    if (!e?.target?.value) { return; }
    if (!(/^[1-9]\d*$/).exec(e?.target?.value) || +e?.target?.value > 50000000) {
      e.target.value = this.selected_causes.filter(item => item.sip_cause === cause)[0].amount;
    }
    const value = e.target.value;
    this.setCauseAmount(cause, value);
    const inputElement = document.getElementById(`${e.target.id}`) as HTMLInputElement;
    if (value === '') {
      inputElement.style.width = '1ch';
    } else if (value) {
      inputElement.style.width = (value.length + 1) + 'ch';
    } else {
      inputElement.style.width = 'auto';
    }
  }

  checkValid() {
    this.show_min_error = false;
    this.cause_list.forEach(el => {
      document.getElementById('cause-' + el.sip_cause)?.classList?.remove('invalid');
    });
    this.selected_causes.forEach(el => {
      if (this.config?.paymentDetails?.min_donation && el.amount < this.config?.paymentDetails?.min_donation) {
        document.getElementById('cause-' + el.sip_cause)?.classList?.add('invalid');
        this.show_min_error = true;
      } else {
        document.getElementById('cause-' + el.sip_cause)?.classList?.remove('invalid');
      }
    });
  }

  setConfig() {
    const payment_method_change = [];
    this.checkValid();
    this.selected_causes = this.selected_causes.map(item => {
      if (!item.amount) {
        item.amount = this.config?.amount || this.paymentV2.getMinSipAmount(this.config?.order?.iso_currency || this.config?.currency || 'INR').amount;
      }
      if (this.config?.show_start_date && this.selectedDate) {
        item.start_date = this.selectedDate;
      }
      if (this.exist_sip.includes(item.sip_cause)) {
        payment_method_change.push(this.user_data.listsubscriptions?.[item.sip_cause]?.id);
      }
      return item;
    });
    this.paymentV2.paymentConfig.next({
      sip_cause: this.selected_causes,
      cart_amount: this.paymentV2.totalSip(this.selected_causes, this.config).total_amount,
      enable_multicause_slection: true,
      payment_method_change: payment_method_change.length > 0 ? payment_method_change : null
    });
    if (this.selected_causes?.length >= 1 && this.vars.pageName.match('impact_portfolio_stories')) {
      this.storage.addSessionData('multicause', { sip_cause: this.selected_causes, amount: this.config.amount, cart_amount: this.config.cart_amount });
    }
    this.min_sip_error = false;
    if (this.selected.includes('sip_protect') && !this.selected.includes('medical') && !this.exist_sip.includes('medical')) {
      this.min_sip_error = true;
    }
  }

  onDateSelected(event: MatDatepickerInputEvent<Date>): void {
    this.selectedDate = this.formatDate(event.value);
    this.setConfig();
  }

  formatDate(date: Date) {
    let reDate = '';
    const dd = date?.getDate();
    const mm = date?.getMonth() + 1;
    reDate = `${date?.getFullYear()}-${mm < 10 ? 0 : ''}${mm}-${dd < 10 ? 0 : ''}${dd}`; //yyyy-mm-dd
    return reDate;
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}
